/**
 * RequireAdmin — route guard.
 *
 * - while "checking" → soft loading bar
 * - if anonymous → redirect to /admin/login with from-state
 * - if must_change_password → redirect to /admin/force-change unless already there
 * - otherwise render children
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const RequireAdmin = () => {
  const { phase, user } = useAuth();
  const location = useLocation();

  if (phase === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-porcelain">
        <div className="w-2 h-2 rounded-full bg-raspberry animate-pulse" />
      </div>
    );
  }
  if (phase !== "authenticated") {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  const onForceChange = location.pathname.startsWith("/admin/force-change");
  if (user?.must_change_password && !onForceChange) {
    return <Navigate to="/admin/force-change" replace />;
  }
  return <Outlet />;
};

export default RequireAdmin;
